import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
const failures = ['Hacer cardio de alta intensidad todos los días dispara tu estrés hormonal y causa retención de líquidos masiva.', 'Mantener un déficit calórico agresivo durante todo el mes agota tus glándulas suprarrenales y sabotea tu tiroides.', 'Ignorar que tu fuerza fluctúa un 20% cada mes te lleva inevitablemente a lesiones y al estancamiento físico.', 'Tratar de "quemar" los antojos pre-menstruales con más ejercicio solo aumenta la inflamación y el hambre.'];
export function FailuresSection() {
  return <section className="py-24 bg-emerald-900 relative" data-id="element-14">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-17">
            POR QUÉ LO QUE HAS INTENTADO{' '}
            <span className="text-red-400" data-id="element-18">NO FUNCIONÓ</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-19">
          {failures.map((failure, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-20">
              <div className="bg-emerald-950/80 border border-emerald-800/50 p-6 rounded-xl flex items-start gap-4 h-full transition-colors hover:border-emerald-700" data-id="element-21">
                <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-22" />
                <p className="text-emerald-50/90 font-body leading-relaxed" data-id="element-23">
                  {failure}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}